import React from "react";

import styles from "./crewTransferMenu.module.scss";

export const StyledCrewTransferHint: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div
    className={`${styles.styledCrewTransferHint} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);
